import React from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import EditableInput from '../../../editableInput';
import { Dropdown, Menu, Balloon } from '@alifd/next';
import { Icon, Input, Message } from '@b-design/fusion';
import NameIcon from '@/components/NameIcon';
import { getQueryStringArgs } from '@/utils/url-parse';
import Requests from '@/services/request';
import Confirm from '@/components/Confirm';
import $i18n from '@/i18n';
import './index.less';

const Tooltip = Balloon.Tooltip;

let dragingIndex = '-1';
let opacity = '1';

// 被拖拽的卡片
const CardSource = {
  // 卡片开始被拖拽时触发
  beginDrag(props, _, component) {
    component.decoratedRef.current.state.dropdownVisible = false;
    dragingIndex = props.value;
    return {
      index: props.index,
    };
  },
  // 卡片结束拖拽时触发
  endDrag(props) {
    dragingIndex = '-1';
    opacity = '1';
    props.newRenderFn();
  },
};

// 目标卡片
const CardTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    if (dragIndex === hoverIndex) return null;
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
    const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
    const clientOffset = monitor.getClientOffset();
    const hoverClientX = clientOffset.x - hoverBoundingRect.left; // 悬浮时鼠标距离目标源的左边距

    if (hoverIndex - dragIndex === 1 && hoverClientX < hoverMiddleX) {
      return null;
    }
    if (dragIndex - hoverIndex === 1 && hoverClientX > hoverMiddleX) {
      return null;
    }

    props.moveSort(dragIndex, hoverIndex);
    monitor.getItem().index = hoverIndex;
  },
};

class CardItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddInput: false,
      dropdownVisible: false,
      tagList: [],
    };
  }
  render() {
    const {
      connectDragSource,
      connectDropTarget,
      value,
      tagLists,
      getTagLists,
      getBindAppList,
      checkItem,
    } = this.props;
    const { isAddInput, dropdownVisible } = this.state;
    const { channelCode } = getQueryStringArgs();
    opacity = value === dragingIndex ? '0.1' : '1';

    // 新增标签
    const sendNewTag = async (e) => {
      const res = await Requests.post('/rest/intercnn/channel/tag/create', {
        channelCode,
        name: e.target.value,
      });
      if (res) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.miniapp.drawer.form.add.successfully',
            dm: '添加成功',
          }),
        });
        getTagLists();
      }
      setIsAddInput(false);
    };

    // 修改标签
    const updateTag = async (e, value) => {
      const res = await Requests.post('/rest/intercnn/channel/tag/update', {
        id: value.id,
        name: e.target.value,
      });
      if (res) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.channel.channelList.message.success',
            dm: '修改成功',
          }),
        });
        getTagLists();
        getBindAppList();
      }
      setIsAddInput(false);
    };

    // 删除标签
    const deleteTag = async (id) => {
      try {
        const res = await Requests.post('/rest/intercnn/channel/tag/delete', {
          channelCode,
          id,
        })
        if (res) {
          Message.success({
            title: $i18n.get({
              id: 'aopf.pages.invitation.spaces.message.deleteSuccess',
              dm: '删除成功',
            }),
          });
          getTagLists();
          getBindAppList();
        }
      } finally{
        setIsAddInput(false);
      }
    };

    // 绑定标签
    const bindTag = async (id) => {
      const res = await Requests.post('/rest/intercnn/channel/category/miniapp/bindTag', {
        channelCode,
        tagId: id,
        categoryId: checkItem,
        miniappCode: value.miniappCode,
      });
      if (res) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.miniAppStore.setting.bind.tag.success',
            dm: '绑定成功',
          }),
        });
        getBindAppList();
      }
      setIsAddInput(false);
    };

    // 解绑标签
    const unbindTag = async (id) => {
      if (id) {
        const res = await Requests.post('/rest/intercnn/channel/category/miniapp/unbindTag', {
          channelCode,
          tagId: id,
          categoryId: checkItem,
          miniappCode: value.miniappCode,
        });
        if (res) {
          Message.success({
            title: $i18n.get({
              id: 'aopf.pages.miniAppStore.setting.unbind.tag.success',
              dm: '解绑成功',
            }),
          });
          getBindAppList();
        }
      } else {
        Message.notice({
          title: $i18n.get({
            id: 'aopf.pages.miniAppStore.setting.please.bind.tag',
            dm: '请先绑定标签',
          }),
        });
      }
    };

    const setDropdownVisible = (v) => {
      this.setState({
        dropdownVisible: v,
      });
    };

    const setIsAddInput = (v) => {
      this.setState({
        isAddInput: v,
      });
    };

    const deleteApp = async () => {
      const res = await Requests.post('/rest/intercnn/channel/category/miniapp/unbind', {
        channelCode,
        categoryId: checkItem,
        miniappCode: value.miniappCode,
      });
      if (res) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.invitation.spaces.message.deleteSuccess',
            dm: '删除成功',
          }),
        });
        getBindAppList();
      }
    };

    const renderAddTags = () => {
      return isAddInput ? (
        <Input
          className="addTagInput"
          style={{ maxWidth: '84px', marginLeft: '16px' }}
          size="small"
          maxLength={30}
          onPressEnter={sendNewTag}
          onBlur={sendNewTag}
        />
      ) : (
        <Menu.Item>
          <div onClick={() => setIsAddInput(true)}>
            <Icon
              type="add--circle--filled"
              size="xs"
              style={{ color: 'var(--superapp-primary-1)', marginRight: '6px' }}
            />
            <span style={{ color: 'var(--superapp-primary-1)' }}>
              {$i18n.get({
                id: 'aopf.pages.miniAppStore.operate.setting.createTag',
                dm: '新建标签',
              })}
            </span>
          </div>
        </Menu.Item>
      );
    };
    return connectDragSource(
      connectDropTarget(
        <div className="card-lists" style={{ opacity }}>
          <div className="member-item">
            <div className="item-content">
              {value.iconPublicUrl ? (
                <img src={value.iconPublicUrl} style={{ width: '48px', height: '48px' }} />
              ) : (
                <NameIcon
                  name={value.name}
                  styles={{ width: '48px', height: '48px', fontSize: '30px' }}
                  shape="square"
                />
              )}

              <Tooltip v2 trigger={<div className="item-content-name">{value.name}</div>} align="b">
                {value.name}
              </Tooltip>
              {value.onlineVersion ? (
                <div className="item-content-version">
                  <span style={{ marginRight: '4px' }}>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.Version',
                      dm: '版本',
                    })}
                  </span>
                  <span>{value.onlineVersion}</span>
                </div>
              ) : (
                <div style={{ height: '20px' }}></div>
              )}
            </div>
            <Icon className="item-icon" type="draggable" size="small" />
            <Confirm
              trigger={<Icon className="item-deleteIcon" type="trash-can--outline" size="small" />}
              dialogTitle={$i18n.get({
                id: 'aopf.pages.miniAppStore.setting.delete',
                dm: '删除小程序',
              })}
              dialogContent={$i18n.get({
                id: 'aopf.pages.miniAppStore.setting.delete.desc',
                dm: '确定删除该小程序？',
              })}
              width={400}
              onClick={deleteApp}
            />
            <div className="item-tagSelect">
              <Dropdown
                trigger={
                  value.channelTagName ? (
                    <div
                      className="item-addTag"
                      onClick={() => {
                        setDropdownVisible(!dropdownVisible);
                        setIsAddInput(false);
                      }}
                    >
                      <Tooltip
                        v2
                        trigger={<div className="addTag-name">{value.channelTagName}</div>}
                        align="b"
                      >
                        {value.channelTagName}
                      </Tooltip>
                      <Icon className="addTag-icon" size="xs" type="caret--down" />
                    </div>
                  ) : (
                    <div
                      className="item-noTag"
                      onClick={() => {
                        setDropdownVisible(!dropdownVisible);
                        setIsAddInput(false);
                      }}
                    >
                      <Icon
                        type="add--circle--filled"
                        size="small"
                        style={{ marginRight: '5px' }}
                      />
                      {$i18n.get({
                        id: 'aopf.pages.miniAppStore.setting.add.tag',
                        dm: '添加标签',
                      })}
                    </div>
                  )
                }
                triggerType="click"
                visible={dropdownVisible}
                onVisibleChange={(v, type) => {
                  if (type === 'docClick') {
                    setDropdownVisible(v);
                  }
                }}
              >
                <Menu style={{ width: '140px', maxHeight: '300px', overflowY: 'auto' }}>
                  {renderAddTags()}
                  {tagLists.map((i) => {
                    return (
                      <EditableInput
                        key={i.name}
                        value={i}
                        setDropdownVisible={setDropdownVisible}
                        updateTag={updateTag}
                        deleteTag={deleteTag}
                        bindTag={bindTag}
                        bindInfo={value}
                      />
                    );
                  })}
                </Menu>
              </Dropdown>
              {value.channelTagId && (
                <Confirm
                  trigger={
                    <Tooltip
                      v2
                      trigger={
                        <div className="item-unbind">
                          <Icon type="unlink" size="xs" />
                        </div>
                      }
                      align="b"
                    >
                      {$i18n.get({
                        id: 'aopf.pages.miniAppStore.setting.unbind.tag',
                        dm: '解绑该标签',
                      })}
                    </Tooltip>
                  }
                  dialogTitle={$i18n.get({
                    id: 'aopf.pages.miniAppStore.setting.category.list.unBind.tag',
                    dm: '解绑标签',
                  })}
                  dialogContent={$i18n.get({
                    id: 'aopf.pages.miniAppStore.setting.unbind.tag.confirm',
                    dm: '确定解绑该标签吗？',
                  })}
                  width={400}
                  onClick={unbindTag.bind(null, value.channelTagId)}
                />
              )}
            </div>
          </div>
        </div>,
      ),
    );
  }
}

export default DragSource('card', CardSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))(
  DropTarget('card', CardTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  }))(CardItem),
);
